var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPmMaestro = function SvgPmMaestro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.111 6.002H1.89C.846 6.002 0 6.822 0 7.835V26.17c0 1.012.846 1.833 1.889 1.833H32.11c1.043 0 1.889-.82 1.889-1.833V7.835c0-1.012-.846-1.833-1.889-1.833Z",
    fill: "#08031D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.645 22.207h-.049v-.283h.073l.094.199.08-.2h.071v.282h-.049v-.212l-.077.183h-.058l-.085-.183v.214Zm-.212 0h-.043v-.235h-.099v-.048h.248v.048h-.106v.234Z",
    fill: "#00A1DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.318 11.115h-7.02v11.97h7.02v-11.97Z",
    fill: "#7272B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.054 17.1a7.723 7.723 0 0 1 2.75-5.985 7.076 7.076 0 0 0-9.868.819 7.86 7.86 0 0 0 0 10.331 7.076 7.076 0 0 0 9.868.819 7.723 7.723 0 0 1-2.75-5.984Z",
    fill: "#ED1C24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.602 17.1a7.65 7.65 0 0 1-4.106 6.842 7.046 7.046 0 0 1-7.691-.857A7.84 7.84 0 0 0 18.028 12.4a7.318 7.318 0 0 0-1.223-1.285 7.045 7.045 0 0 1 7.691-.858 7.65 7.65 0 0 1 4.106 6.842Z",
    fill: "#00A1DE"
  })));
};
export default SvgPmMaestro;